import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import { SortableWidgetProps, Widget } from '@creditsights/styleguide-web';
import { isEmpty } from 'lodash';
import { ROUTES } from '../../../Base.constants';
import useFetchAnnouncements from '../../../hooks/announcements/useFetchAnnouncements';
import useCheckArticleAccessStatus from '../../../hooks/articles/useCheckArticleAccessStatus';
import { getArticleMouseClickHandler } from '../../../utils/articleUtils';
import { openWindowInNewTab } from '../../../utils/navigationUtils';

import styles from './AnnouncementsWidget.module.scss';

const cx = classNames.bind(styles);

const AnnouncementsWidget = (props: SortableWidgetProps, ref): React.ReactElement => {
  const { data: announcements = [], isLoading, isError, refetch } = useFetchAnnouncements();
  const checkArticleAccessStatus = useCheckArticleAccessStatus();
  const mouseClickHandler = getArticleMouseClickHandler(({ id }) =>
    checkArticleAccessStatus(id, () => openWindowInNewTab(ROUTES.article(id)))
  );

  const renderAnnouncements = () => {
    if (isEmpty(announcements)) {
      return <p>No announcements.</p>;
    }
    return (
      <div className={cx('body')} data-testid="announcements" onClick={mouseClickHandler}>
        {announcements.map((announcement, i) => (
          <a
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            className={cx('item')}
            href={announcement.link}
            target="_blank"
            rel="noreferrer"
            style={announcement.image ? { backgroundImage: `url(${announcement.image.url})` } : {}}
            data-testid="announcement-item"
          >
            <span className={cx('title')} data-testid="announcement-title">
              {announcement.linkTitle}
            </span>
          </a>
        ))}
      </div>
    );
  };

  return (
    <Widget
      headerTitle="Announcements"
      isLoading={isLoading}
      isError={isError}
      fixedHeight
      onRetryAfterErrorClick={refetch}
      ref={ref}
      {...props}
    >
      {renderAnnouncements()}
    </Widget>
  );
};

export default forwardRef(AnnouncementsWidget);
